<template>
  <div id="bottomNav" class="bottom-nav d-print-none d-flex align-center justify-start" :class="`${bottomNav.bg} ${bottomNav.color}--text`">
    <div class="d-flex mx-auto justify-center" style="position: relative; width: 100%; height: 100%; max-width: 1904px">
      <!-- home -->
      <div v-if="xs" class="d-flex flex-column align-center" :style="{ position: 'absolute', left: 0, top: 0, bottom: 0, width: itemWidth + 'px' }">
        <v-btn @click="goHome" icon class="d-flex mx-1 mx-sm-6 mx-md-5 mx-lg-10">
          <v-icon :color="homeColor"> mdi-home</v-icon>
        </v-btn>
        <span class="d-flex op-text-xs" :class="`${homeColor}--text`">Home</span>
      </div>
      <div
        class="bottom-nav-inner horizontal-scroll-container align-start justify-center"
        :style="`left:60px;right:${statusContainerWidth}px;${xs ? '' : 'justify-content: center'}`"
      >
        <!-- Scroll container width widget and module links, font-size settings-->
        <div class="d-flex justify-center" :style="`width:${itemWidth * (bottomNavigation.length + 1)}px`">
          <!-- Home -->
          <div v-if="!xs" class="d-flex flex-column align-center">
            <v-btn @click="goHome" icon class="d-flex mx-1 mx-sm-6 mx-md-5 mx-lg-10">
              <v-icon :color="$route.path === '/' ? bottomNav.activeColor : bottomNav.color"> mdi-home</v-icon>
            </v-btn>
            <span class="d-flex op-text-xs" :class="`${$route.path === '/' ? bottomNav.activeColor : bottomNav.color}--text`">Home</span>
          </div>
          <!-- Bottom Navigation configured items-->
          <div
            v-for="(item, index) in bottomNavigation"
            class="d-flex flex-column align-center"
            :style="{ width: itemWidth + 'px' }"
            :key="index"
            @click="navigateTo(item)"
          >
            <v-btn link icon class="d-flex mx-1 mx-sm-6 mx-md-5 mx-lg-10">
              <img-icon
                v-if="item.imgIcon"
                :color="selectedNavItem(item) ? bottomNav.activeColor : bottomNav.color"
                :style="selectedNavItem(item) ? '' : 'filter:brightness(0.8)'"
                :icon="item.imgIcon"
              ></img-icon>
              <v-icon v-else :color="selectedNavItem(item) ? bottomNav.activeColor : bottomNav.color" :style="item.iconStyle">
                {{ item.icon }}
              </v-icon>
            </v-btn>
            <template>
              <bottom-nav-badge :bottomNavItem="item" :badgeColor="theme.unreadBadgeColor" :moduleConfig="moduleConfig(item)"></bottom-nav-badge>
            </template>
            <span class="d-flex op-text-xs" :class="`${selectedNavItem(item) ? bottomNav.activeColor : bottomNav.color}--text`">{{
              $te(item.title) ? $t(item.title) : item.title
            }}</span>
          </div>
        </div>

        <!-- font-size settings -->
        <div v-if="mdAndUp" class="ml-3 d-flex flex-column align-items-center justify-center">
          <div class="d-flex mt-3 px-2">
            <div
              v-for="fontSize in fontSizes"
              :key="fontSize.value"
              class="mt-0 op-text text-center d-flex justify-center align-center px-3"
              style="height: 25px"
              :style="`font-size:${fontSize.displaySize}px !important`"
              @click="setFontSize(fontSize.value)"
              :class="`${fontSize.css} ${userProfile.baseFontSize === fontSize.value ? bottomNav.activeColor : bottomNav.color}--text`"
            >
              {{ fontSize.t }}
            </div>
          </div>
          <div class="d-flex justify-center op-text-xs" :class="`${theme.bottomNav.color}--text`" style="font-size: 10px">
            {{ $t('fontSize') }}
          </div>
        </div>
      </div>
      <!-- right-aligned status monitor -->
      <status-monitor :width="statusContainerWidth" class="status-container"></status-monitor>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import navigationMixin from '@/mixins/navigationMixin';
import StatusMonitor from '@/components/icons/StatusMonitor';
import BottomNavBadge from './BottomNavBadge';
import ImgIcon from '@/components/icons/ImgIcon';

export default {
  name: 'BottomNav',

  mixins: [common, configMixin, navigationMixin],

  components: {
    ImgIcon,
    StatusMonitor,
    BottomNavBadge,
  },

  data: () => ({
    fontSizes: [
      { css: 'op-text', value: 16, displaySize: 16, t: 'M' },
      { css: 'op-text-l', value: 18, displaySize: 24, t: 'L' },
      { css: 'op-text-xl', value: 20, displaySize: 30, t: 'XL' },
    ],
  }),

  computed: {
    ...mapState({
      snackbar: (state) => state.snackbar,
      bottomNavigation: (state) => state.configs.bottomNavigation,
      acknowledgeDocument: (state) => state.acknowledgeDocument,
      isSynchronizing: (state) => state.sync.isSynchronizing,
      currentSync: (state) => state.sync.currentSync,
      isDisconnected: (state) => !state.isConnected,
      userProfile: (state) => state.profile.userProfile,
    }),
    ...mapState(['isConnected', 'isServerReachable', 'connectionType', 'isToolbarsHidden']),
    bottomNav() {
      return this.theme.bottomNav;
    },

    homeColor() {
      return this.$route.path === '/' ? this.bottomNav.activeColor : this.bottomNav.color;
    },
    itemWidth() {
      return this.xs ? 60 : 100;
    },
    path() {
      return this.$route.path;
    },
    statusContainerWidth() {
      return 90;
    },
    activeTextColor() {
      return this.theme.bottomNav.activeTextColor ? this.theme.bottomNav.activeTextColor : 'grey--text text--lighten-4';
    },
    inActiveTextColor() {
      return this.theme.bottomNav.inactiveTextColor ? this.theme.bottomNav.inactiveTextColor : 'grey--text';
    },
  },
  methods: {
    goHome() {
      if (this.$route.path !== '/') {
        this.$router.push('/');
      }
    },

    buildBottomNavRoute(navItem) {
      if (navItem.pageClass === 'Module') {
        let moduleConfig = this.moduleConfig(navItem);
        return this.buildRoute(moduleConfig);
      }
      return `/${navItem.path}`;
    },
    selectedNavItem(navItem) {
      let navRoute = this.buildBottomNavRoute(navItem);
      return this.path.includes(navRoute);
    },
    setFontSize(size) {
      let userProfile = this.userProfile;

      let r = document.querySelector(':root');
      r.style.setProperty('--base-font-size', size + 'px');
      this.$store.commit('profile/setUserProfile', { ...userProfile, baseFontSize: size });
      console.debug('userProfile', JSON.stringify(this.userProfile, null, 2));
    },
    navigateTo(item) {
      let route = this.buildBottomNavRoute(item);

      if (this.$route.fullPath !== route) {
        this.$router.push(route);
      }
    },
    moduleConfig(item) {
      let { pageType, pageClass, pageInstance } = item;
      if (pageClass === 'Module') {
        return this.getModuleConfig(pageType, pageInstance);
      }
      return null;
    },
    iconClass(navItem) {
      return navItem.iconStyle;
    },
  },
};
</script>
<style scoped>
.bottom-nav {
  transition: transform 0.5s ease-in-out;
  z-index: 100;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 54px;
  margin-left: auto;
  margin-right: auto;
}

@supports (-webkit-touch-callout: none) {
  /* CSS specific to iOS devices */
  .bottom-nav {
    height: 66px; /* nudge-safe height*/
  }
}

/*@supports not (-webkit-touch-callout: none) {*/
/*  !* CSS for other than iOS devices *!*/
/*}*/
.bottom-nav-inner {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 80px;
  display: flex;
}

.status-container {
  transition: all 0.5s ease-in-out;
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  width: 80px;
}
</style>
